import { Component, ElementRef, Input, Renderer2 } from '@angular/core'

@Component({
  selector: 'app-primary-card',
  templateUrl: './primary-card.component.html',
  styleUrls: ['./primary-card.component.scss'],
  standalone: false,
})
export class PrimaryCardComponent {
  @Input() title: string = ''
  @Input() subtitle: string = ''
  @Input() size:
    | 'tiny'
    | 'small'
    | 'medium'
    | 'x-medium'
    | 'large'
    | 'x-large'
    | 'full'
  @Input() headerSize: 'small' | 'medium' = 'medium'
  @Input() paddingSize: 'none' | 'medium' | 'large' = 'none'
  @Input() height: number
  class: string[] = ['primary-card']

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}

  ngOnInit() {
    this.class.push(this.BuildCardSize(this.size ?? 'medium'))

    if (this.paddingSize !== 'none') {
      this.class.push(`primary-card-padding-${this.paddingSize}`)
    }
  }

  BuildCardSize(size: string | undefined): string {
    const cardSizePrefix = 'primary-card'
    const safeSize = size ?? 'medium'
    return `${cardSizePrefix}-${safeSize}`
  }

  flashForASecond(): void {
    const element = this.el.nativeElement.querySelector('.flashable-item')

    if (element) {
      // Add the flash class
      this.renderer.addClass(element, 'flash-effect')

      // Remove the flash class after 1 second
      setTimeout(() => {
        this.renderer.removeClass(element, 'flash-effect')
      }, 1000) // 1000ms = 1 second
    }
  }
}
